import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import ScrollToTop from "@/components/ScrollToTop";
import Header from "@/components/Header";
import StickyContactButton from "@/components/StickyContactButton";
import SubdomainRedirect from "@/components/SubdomainRedirect";
import { Outlet } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";

/**
 * Root layout component wrapping all routes.
 * Provides global context, UI elements, and layout structure.
 *
 * During SSG, vite-react-ssg provides its own outer HelmetProvider
 * that captures <Helmet> tags for static HTML extraction.
 * Adding a second provider here would shadow it and prevent extraction.
 * On the client (dev preview + production hydration), we need our own
 * HelmetProvider because the SSG wrapper is not present at runtime.
 */
const RootLayout = () => {
  const isBrowser = !import.meta.env.SSR;

  const content = (
    <TooltipProvider>
      {isBrowser && <SubdomainRedirect />}
      {isBrowser && <Toaster />}
      {isBrowser && <Sonner />}
      {isBrowser && <ScrollToTop />}
      {isBrowser && <Header />}
      {isBrowser && <StickyContactButton />}
      <Outlet />
    </TooltipProvider>
  );

  // Client: wrap with HelmetProvider (needed for Helmet context)
  // SSG: return without wrapper (let vite-react-ssg's provider capture tags)
  if (isBrowser) {
    return <HelmetProvider>{content}</HelmetProvider>;
  }

  return content;
};

export default RootLayout;
